import React from 'react'
import { useProfileForm } from 'utils/providers/ProfileFormProvider'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { useAnalytics } from 'utils/providers/AnalyticsProvider'

import { FormikStep, FormikStepper, UserProfile } from 'shared'
import { getInitialValues } from '../config'
import { createProfile } from 'api/auth'
import { ANALYTICS_EVENT_NAMES } from 'constants/analytics'

const ProfileFormSteps = () => {
  const { steps, onStepChange, activeStep, user } = useProfileForm()
  const [, setParams] = useSearchParams()
  const { analyticsTrack } = useAnalytics()

  const queryClient = useQueryClient()

  const updateUser = useMutation({
    mutationKey: ['profile_form'],
    mutationFn: createProfile,
    onSuccess: () => {
      setParams((p) => {
        p.delete('profile-form-step')
        return p
      })
      queryClient.invalidateQueries({ queryKey: ['user'] })
    },
  })

  const _onStepChange = (id: number, currValues: object | null) => {
    if (steps[activeStep]) {
      steps[activeStep].onForward()
    }
    onStepChange(id, currValues)
  }

  return (
    <FormikStepper
      initialValues={getInitialValues(user)}
      onSubmit={(values) => {
        const { validationErrors, ...profileData } = values
        // @ts-expect-error bad types
        profileData.attributes = profileData.attributes.filter((attr) => {
          return attr.value !== null
        })

        if (Object.values(validationErrors).filter(Boolean).length) {
          return
        }

        analyticsTrack(
          `${ANALYTICS_EVENT_NAMES.application}: Creator Agreement Page Completed (Submitted)`
        )

        updateUser.mutate({
          ...profileData,
          profileImageUrl: user?.profile.profileImageUrl,
          address: {
            ...profileData.address,
            id: user?.profile?.address?.id,
          },
        } as unknown as UserProfile)
      }}
      onStepChange={_onStepChange}
      step={activeStep}
    >
      {steps.map((el) => (
        <FormikStep key={el.id} validationSchema={el.validationSchema}>
          <el.Component />
        </FormikStep>
      ))}
    </FormikStepper>
  )
}

export default ProfileFormSteps
